<template>
  <div>
    <b-modal 
      id="th-exp-image-modal" 
      ref="th-exp-img-modal-ref" 
      hide-footer 
      title="Experience Images"
    >
      <div class="mb-5 mt-5">
        <Slider 
          :images="images" 
          :controls="true" 
          image-size="large"
        />
      </div>
    </b-modal>
  </div>
</template>
  
<script>
import Slider from '../slider/index.vue'
export default {
  name: 'TouringExperienceImages',
  components: {
    Slider
  },
  props: {
    experienceItem: {
      type: Object
    }
  },
  data() {
    return {
      images: [],
      activeItemIndex: 0
    }
  },
  computed: {
    activeItem () {
      return this.activeItemIndex
    }
  },
  mounted () {
    this.getExperienceData(0)
  },
  methods: {
    showModal() {
      this.$refs["th-exp-img-modal-ref"].show();
    },
    getExperienceData (placeIndex) {
      // Set active item
      this.activeItemIndex = placeIndex
      // Get any other images
      const images = this.experienceItem.media.images
      // combine in image array
      this.images = [...images]
    },
    handleSelect (placeIndex) {
      this.getPlaceData(placeIndex)
    }
  },
}
</script>
  
<style lang="scss">
.places {
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: auto;
  white-space: nowrap;
}
.place-select {
  cursor: pointer;
}
.active-place {
  font-weight: bold;
}
</style>